import PropTypes from 'prop-types';
import { useRef } from 'react';
import * as yup from 'yup';

import { useSponsorshipTypes, useCreateSponsorshipType, useUpdateSponsorshipType, useDeleteSponsorshipType } from 'hooks/useBeneficiaries';
import CrudCard from '../../common/CrudCard/CrudCard';
import { useAuthContext } from 'context/authContext';

/* -------------------------------------------------------------------------- */
function SponsorshipTypes({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();
  const { organization } = useAuthContext();
  const { sponsorshipTypes } = useSponsorshipTypes();
  const { createSponsorshipType, isCreating } = useCreateSponsorshipType();
  const { updateSponsorshipType, isUpdating } = useUpdateSponsorshipType();
  const { deleteSponsorshipType, isDeleting } = useDeleteSponsorshipType();

  const handleCreate = ({ type }) => {
    createSponsorshipType({
      type,
      organisation_id: organization.id
    }, {
      onSuccess: () => {
        cardRef.current.onCreationSuccess();
      }
    });
  };

  const handleEdit = ({ id, data }) => {
    updateSponsorshipType({
      id,
      data: { type: data.type }
    }, {
      onSuccess: () => {
        cardRef.current.onEditSuccess();
      }
    });
  };

  const handleDelete = (id) => {
    deleteSponsorshipType(id, {
      onSuccess: () => {
        cardRef.current.onDeleteSuccess();
      }
    });
  };

  const list = sponsorshipTypes?.map(type => ({
    id: type.id,
    isOrgLevel: !type.branch_id,
    values: [
      {
        value: type.type,
        name: 'type'
      }
    ]
  }));

  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      editData={handleEdit}
      deleteData={handleDelete}
      createLoading={isCreating}
      updateLoading={isUpdating}
      deleteLoading={isDeleting}
      formTitle={'Add Sponsorship Type'}
      listTitle={'Current Sponsorship Type'}
      title={'Sponsorship Types'}
      inputs={[
        {
          name: 'type',
          placeholder: 'Add Sponsorship Type',
          type: 'text',
          required: true,
          value: '',
          validation: yup.string().required('Sponsorship Type is required')
        }
      ]}
      list={list}
      subject={subject}
    />
  );
}

SponsorshipTypes.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default SponsorshipTypes;
